// extracted by mini-css-extract-plugin
export default {"tip":"LocationTab_tip__jioFt"};